import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular/lazy';
import { AbstractComponentMobile } from '../../abstract/abstract-component-global.directive';

@Component({
    selector: 'web-arrow-button',
    templateUrl: './arrow-button.component.html',
    styleUrls: ['./arrow-button.component.scss'],
    imports: [IonicModule],
})
export class ArrowButtonComponent extends AbstractComponentMobile {
    public override tag = '[ArrowButtonComponent]';

    @Input()
    public label = '';

    @Input()
    public leftIcon?: string;

    @Input()
    public rightIcon?: string | null;

    @Input()
    public disabled = false;
}
